import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  margin-bottom: 15px;
`;

interface NoResultsProps {
  value: string;
}

const NoResults: React.FC<NoResultsProps> = ({ value }) => (
  <StyledDiv>{`No results for "${value}"`}</StyledDiv>
);

export default NoResults;
